<template>
  <img :src="src" :alt="alt" :height="height" :width="width" />
</template>
<script>
export default {
  props: {
    url: {
      type: String
    },
    alt: {
      type: String
    },
    height: {
      type: String
    },
    width: {
      type: String
    }
  },
  mounted() {},
  methods: {},
  computed: {
    src() {
      const path = process.env.VUE_APP_BASE_PATH;
      return path + this.url;
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped></style>
